import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';
import { UmbracoProductFeature } from '@shared/types';

import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import GatsbyImage from 'common/GatsbyImage';

import './ProductFeaturesMain.scss';
import './ShadowProductFeaturesMain.scss';
import { IPropsProductFeaturesMain } from './models';

const ProductFeaturesMain: FC<IPropsProductFeaturesMain> = ({ items }): ReactElement | null => (
  <div data-test="ProductFeaturesMain" className="product-features-main">
    {items.map((item: UmbracoProductFeature.IData) => (
      <div
        key={item?.iconId?.[0]?.properties?.names?.[0] || item.text}
        className={classNames('feature-item', {
          [`feature-item--icon-only`]: !((item?.label && item?.text) || item?.textRte),
        })}
      >
        <div className="feature-item-icon-wrapper">
          <GatsbyImage image={item.icon} alt={item.iconAlt} className="feature-item-icon" />
        </div>
        {item?.label || item?.text || item?.additionalTextRTE || item?.textRte ? (
          <div className="feature-item-info">
            {item?.label ? <strong className="feature-item-title">{item.label}</strong> : null}
            {item?.text ? (
              <p
                className={classNames('feature-item-text', {
                  'feature-item-text--bold': !item?.label,
                })}
              >
                {item.text}
              </p>
            ) : null}
            {item?.textRte ? (
              <DangerouslySetInnerHtml
                html={item.textRte}
                className="feature-item-text additional"
              />
            ) : null}
            {item?.additionalTextRTE ? (
              <DangerouslySetInnerHtml
                html={item.additionalTextRTE}
                className="feature-item-text-rte"
              />
            ) : null}
          </div>
        ) : null}
      </div>
    ))}
  </div>
);

export default ProductFeaturesMain;
